import React from 'react';

const BlogCard = ({ blog, onView, onEdit, onDelete }) => {
  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString('en-IN', {
      day: '2-digit', month: 'short', year: 'numeric',
    });
  };

  // Strip HTML tags for preview
  const stripHtml = (html) => html?.replace(/<[^>]*>/g, '') || '';

  return (
    <div className="bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300 overflow-hidden group border border-gray-100">
      {/* Image */}
      <div className="relative h-48 overflow-hidden bg-gray-100">
        {blog.images?.[0] ? (
          <img
            src={blog.images[0]}
            alt={blog.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gray-300">
            <span className="text-5xl">📝</span>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
        <span className="absolute bottom-3 left-3 bg-green-600 text-white text-xs font-semibold px-2.5 py-1 rounded-full">
          Blog
        </span>
        {blog.images?.length > 1 && (
          <span className="absolute top-3 right-3 bg-black/50 text-white text-xs px-2 py-0.5 rounded-full">
            +{blog.images.length - 1} photos
          </span>
        )}
      </div>

      {/* Content */}
      <div className="p-4">
        <h3 className="text-base font-bold text-gray-800 line-clamp-2 leading-snug">
          {blog.title}
        </h3>

        <p className="text-xs text-gray-500 mt-2 line-clamp-3 leading-relaxed">
          {stripHtml(blog.content)}
        </p>

        {/* Date */}
        <div className="flex items-center gap-1.5 mt-3">
          <span className="text-xs text-gray-400">📅</span>
          <span className="text-xs text-gray-400">{formatDate(blog.publishedDate)}</span>
        </div>

        {/* Actions */}
        <div className="flex gap-2 mt-4 pt-4 border-t border-gray-100">
          <button
            onClick={onView}
            className="flex-1 py-2 rounded-lg bg-gray-50 hover:bg-gray-100 text-gray-600 text-sm font-medium transition"
          >
            👁️ View
          </button>
          <button
            onClick={onEdit}
            className="flex-1 py-2 rounded-lg bg-blue-50 hover:bg-blue-100 text-blue-600 text-sm font-medium transition"
          >
            ✏️ Edit
          </button>
          <button
            onClick={onDelete}
            className="flex-1 py-2 rounded-lg bg-red-50 hover:bg-red-100 text-red-500 text-sm font-medium transition"
          >
            🗑️
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;